<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="BaseBranchCablePrices"
        height="62vh">
      <div slot="toolbar" class="toolbar">
        <el-button type="primary" :loading="exportLoading" @click="exportData()">导出</el-button>
        <el-button type="primary" plain :loading="exportLoading2" @click="selectCuProperty">下载导入模板</el-button>
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            title="选择铜价"
            width="450px"
            top="10vh"
            @close="dialogClose">
          <el-form
              ref="form"
              :model="filter"
              :rules="ruleValidate"
              class="form"
              label-width="80px">
            <el-form-item label="铜价" prop="cuPriceDisplayValue">
              <el-select v-model.trim="filter.cuPriceDisplayValue" clearable placeholder="请选择">
                <el-option
                    v-for="item in cuPropertyList"
                    :key="item.id"
                    :label="item.displayValue"
                    :value="item.displayValue"/>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer">
            <el-button @click="dialogVisible=false">取消</el-button>
            <el-button :loading="submitLoading2" type="primary" @click="exportFileJD()">确认</el-button>
          </span>
        </el-dialog>
        <el-button icon="el-icon-upload2" type="success" style="margin-left: 5px" @click="dialogVisible2 = true">导入</el-button>
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible2"
            title="提示"
            width="450px"
            top="10vh"
            @close="dialogClose2">
          <div>只需维护面价！</div>
          <span slot="footer">
            <el-button @click="dialogVisible2=false">取消</el-button>
            <el-upload
                :action="uploadUrl"
                :headers="uploadHeaders"
                :before-upload="beforeAvatarUpload"
                :disabled="disabled"
                :on-error="handlerError"
                :on-exceed="onExceed"
                :on-progress="onProgress"
                :on-success="handleSuccess"
                :show-file-list="false"
                accept=".xlsx"
                style="display: inline-block;margin: 0 5px">
              <el-button type="primary" :loading="importLoading">导入</el-button>
            </el-upload>
          </span>
        </el-dialog>
      </div>
      <div slot="adSearch">
        <vm-search label="物料名称">
          <el-input v-model="filter.materialName" placeholder="请输入物料名称" clearable/>
        </vm-search>
        <vm-search label="轿顶分支线名称" style="width: 300px;">
          <el-select v-model="filter.branchNameProperty" clearable>
            <el-option
                v-for="item in branchNameOptions"
                :key="item.id"
                :label="item.displayValue"    
                :value="item.propertyValue"/>
          </el-select>
        </vm-search>
        <vm-search label="轿顶分支线类型" style="width: 300px;">
          <el-input v-model="filter.branchType" placeholder="请输入轿顶分支线类型" clearable/>
        </vm-search>
        <vm-search label="铜价">
          <el-input v-model="filter.cuPriceDisplayValue" placeholder="请输入铜价" clearable/>
        </vm-search>
      </div>
      <el-table-column label="物料名称" prop="materialName" align="left" width="180"/>
      <el-table-column
          label="轿顶分支线名称"
          prop="branchName"
          align="left"
          min-width="350"
          show-overflow-tooltip/>
      <el-table-column label="轿顶分支线类型" prop="branchType" align="left" width="120"/>
      <el-table-column label="轿顶分支线类型" prop="branchType" align="left" width="120"/>
      <el-table-column label="铜价" prop="cuPriceDisplayValue" align="center" width="60"/>
      <el-table-column label="标准价格" prop="standardPrice" align="center" width="70"/>
      <el-table-column label="成本价格" prop="costPrice" align="center" width="70"/>
      <el-table-column label="谊新结算价" prop="yiXinSettlementPrice" align="center" width="100"/>
      <el-table-column label="销售员" prop="level1Price" align="center" width="60"/>
      <el-table-column label="区总" prop="level2Price" align="center" width="60"/>
      <el-table-column label="总监" prop="level3Price" align="center" width="60"/>
      <el-table-column label="操作" align="center" width="80">
        <template v-slot="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <edit-page ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";
  import EditPage from "./BaseBranchCablePricesEdit";
  import loginUtil from "@/util/loginUtil";
  export default {
    components:{ VmTable, VmSearch,EditPage},
    data() {
      return {
        exportLoading:false,
        exportLoading2:false,
        dialogVisible:false,
        dialogVisible2:false,
        submitLoading:false,
        submitLoading2:false,
        importLoading:false,
        disabled: false,
        isShow: false,
        uploadUrl: window.config.basicServerUrl + "BaseBranchCablePrices/importExcel",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        cuPropertyList:[],
        filter:{
          materialName:"",
          branchType:"",
          cuPriceDisplayValue:"",
        },
        branchNameOptions:[],
        ruleValidate: {
          cuPriceDisplayValue:{required: true, message: "铜价不能为空",trigger: "blur"},
        },
      };
    },
    mounted() {
      this.getList();
      this.getBranchNameOptions();
    },
    methods:{
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      getBranchNameOptions() {
        this.$http.get("basic","BaseBranchCablePrices/selectBranchNamePropertyList").then(res=>{
          this.branchNameOptions = res;
        });
      },

      //导出
      exportData() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","BaseBranchCablePrices/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      //
      selectCuProperty() {
        this.dialogVisible = true;
        this.getCablePrices();
      },
      //获取铜价列表
      getCablePrices() {
        this.$http.get("basic","CablePrices/cuProperty")
          .then(res=>{
            console.log(res);
            this.cuPropertyList = res;
          });
      },
      //关闭铜价弹窗
      dialogClose() {
        this.$refs.form.resetFields();
      },
      //根据铜价导出模板
      exportFileJD() {
        console.log(this.filter);
        this.submitLoading2 = true;
        this.$http
          .exportFile("basic","BaseBranchCablePrices/downloadFile", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = "轿顶分支价格.xlsx";
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.submitLoading2 = false;
            this.dialogVisible = false;
          })
          .catch(() => {
            this.submitLoading2 = false;
            this.dialogVisible = false;
          });
      },

      //导入
      dialogClose2() {
        this.dialogVisible2 = false;
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.dialogVisible2 = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        this.dialogVisible2 = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>

<style>

</style>